/**
 * Converts patient data object into array format with auto-incremental UUIDs
 * @param patientData - Object containing patient data
 * @param createdBy - Creator information
 * @param createdOn - Creation date/time
 * @returns Array of patient objects with auto-incremental UUIDs
 */
export const convertPatientDataToArray = (
    patientData: Record<string, string>,
    createdBy: string = "",
    createdOn: string = ""
  ): Array<{
    uuid: string;
    patient: Record<string, string>;
    createdBy: string;
    createdOn: string;
  }> => {
    if (!patientData || typeof patientData !== 'object') {
      return [];
    }
  
    return Object.entries(patientData).map(([key, value], index) => ({
      uuid: (index + 1).toString(), // Auto-incremental UUID starting from 1
      patient: { [key]: value },
      createdBy,
      createdOn,
    }));
  };

